import moment from 'moment';

function checkEmptyField(text) {
  return text || 'vide';
}

function appendChange(fieldName, oldValues, newValues, key, isCreation) {
  const hasKey = !!newValues && Object.hasOwn(newValues, key);

  if (isCreation) {
    return hasKey ? `${fieldName} : ${newValues[key]}\n` : '';
  }

  const oldValue = checkEmptyField(oldValues?.[key]);
  const newValue = hasKey ? checkEmptyField(newValues?.[key]) : '';
  if (hasKey && newValue !== oldValue) {
    return `${fieldName} : ${oldValue} -> ${newValue}\n`;
  }
  return '';
}

function buildResourceMessage(oldValues, newValues, features, isCreation) {
  let msg = '';
  msg += appendChange('Prénom', oldValues, newValues, 'firstname', isCreation);
  msg += appendChange('Nom', oldValues, newValues, 'lastname', isCreation);
  msg += appendChange('Email', oldValues, newValues, 'email', isCreation);
  msg += appendChange('Portable', oldValues, newValues, 'phone_mobile', isCreation);
  msg += appendChange('Fixe', oldValues, newValues, 'phone_office', isCreation);
  msg += appendChange('Adresse', oldValues, newValues, 'address', isCreation);
  msg += appendChange('Complément', oldValues, newValues, 'address_complement', isCreation);
  msg += appendChange('Code postal', oldValues, newValues, 'postcode', isCreation);
  msg += appendChange('Ville', oldValues, newValues, 'city', isCreation);
  msg += appendChange('Num. sécu', oldValues, newValues, 'national_insurance_number', isCreation);

  if (features?.demandEmergency) {
    msg += appendChange('Personne à prévenir en cas d’urgence', oldValues, newValues, 'emergency_name', isCreation);
    msg += appendChange("Mobile d'urgence", oldValues, newValues, 'emergency_phone_mobile', isCreation);
    msg += appendChange("Fixe d'urgence", oldValues, newValues, 'emergency_phone_office', isCreation);
  }

  return msg.trim();
}

function buildTitleAndBodyForPartner(values, features) {
  const { type_id: typeId, demandInfos: oldValues, fields: newValues } = values;
  let title = '';
  let body = '';

  switch (typeId) {
    case 0: // Nouvel agent
      title = "Demande de création d'un nouvel agent";
      body = buildResourceMessage(oldValues, newValues, features, true);
      break;
    case 1: // Modification agent
      title = `Demande de modification d'informations de l'agent ${oldValues?.fullname}`;
      body = buildResourceMessage(oldValues, newValues, features);
      break;
    case 2: // Document agent
      title = `Demande d'ajout de document à l'agent ${oldValues?.fullname}`;
      break;
    case 3: // Modification société
      console.warn('Unavailable feature : edit company');
      break;
    case 4: // Document société // "Demande d'ajout d'un document à la société"
      title = `Demande d'ajout d'un document à la société ${oldValues?.name}`;
      break;
    case 5: // Facture bon de commande
      title = `Demande d'ajout d'une facture associée à la commande n°${oldValues?.code}`;
      break;
    case 6: // Planning bon de commande
      title = `Demande d'ajout d'un planning associé à la commande n°${oldValues?.code}`;
      break;
    case 7: // Demande de sortie d'agent
      title = `Demande de sortie des effectifs de l'agent ${oldValues?.fullname}`;
      break;
    default:
      console.warn(`Unknown partner demand type ${typeId}`);
      break;
  }

  return { title, body };
}

function buildTitleAndBodyForResource(oldValues, newValues, features, currency) {
  const {
    amount,
    firstname,
    lastname,
    type_id: typeId,
    unavailability_type_name: unavailabilityTypeName,
    unavailability_date_start: unavailabilityDateStart,
    unavailability_date_end: unavailabilityDateEnd,
    unavailability_is_day
  } = newValues;
  let title = '';
  let body = '';

  switch (typeId) {
    case 1: // Edit resource
      title = `Demande de modification d'informations de l'agent ${lastname} ${firstname}`;
      body = buildResourceMessage(oldValues, newValues, features);
      break;

    case 2: // Unavailability
      {
        // En 1.9.2, le format du champ passe d'un date à un datetime
        const formatDateVersion = features?.canMakeHourlyUnavailabilityDemand ? 'DD/MM/YYYY HH:mm:ss' : 'DD/MM/YYYY';
        const dateFormat = 'DD/MM/YYYY';

        if (!unavailability_is_day && features?.canMakeHourlyUnavailabilityDemand) {
          const timeFormat = 'HH:mm';
          title = `Demande d'indisponibilité ${unavailabilityTypeName} 
        du ${moment(unavailabilityDateStart, formatDateVersion).format(dateFormat)}
        de ${moment(unavailabilityDateStart, formatDateVersion).format(timeFormat)} à ${moment(unavailabilityDateEnd, formatDateVersion).format(timeFormat)}`;
        } else {
          title = `Demande d'indisponibilité ${unavailabilityTypeName} 
        du ${moment(unavailabilityDateStart, formatDateVersion).format(dateFormat)} 
        au ${moment(unavailabilityDateEnd, formatDateVersion).format(dateFormat)}`;
        }
      }
      break;
    case 3: // Deposit
      title = `Demande d'acompte de ${amount} ${currency}`;
      break;
    case 4: // Other demand
    case 5: // Unused
    case 6: // Simple quote
    case 7: // Detailed quote
    case 8: // Candidate
    case 9: // Quote validation
    case 10: // Documents
      break;
    default:
      console.warn(`Unknown resource demand type ${typeId}`);
      break;
  }

  return { title, body };
}

function getMessage(oldValues, newValues, features, isPartner, isResource, currency) {
  const { type_id: typeId } = newValues;

  if (typeId != null) {
    if (isPartner) {
      return buildTitleAndBodyForPartner(newValues, features, currency);
    }
    if (isResource) {
      return buildTitleAndBodyForResource(oldValues, newValues, features, currency);
    }
  }
  return { title: '', body: '' };
}

export default getMessage;
